import { useMutation } from '@tanstack/react-query'
import {
    startExtractConversation,
    selectExtractPreset,
    modifyExtractConfig,
    acceptExtractConfig,
    cancelExtractConversation,
} from './connectorConversationApi'

/**
 * Hook for managing connector configuration conversations
 * Provides mutations for all conversation operations
 */
export const useConnectorConversation = () => {
    // Start a new conversation
    const { mutate: startConversation, isPending: startingConversation } = useMutation({
        mutationFn: ({ connectorType, connectionKey, workspaceID }) =>
            startExtractConversation({ connectorType, connectionKey, workspaceID }),
        onSuccess: (response, variables) => {
            if (variables?.onSuccess) variables.onSuccess(response)
        },
        onError: (error, variables) => {
            if (variables?.onError) variables.onError(error)
        },
    })

    // Select a preset or provide custom intent
    const { mutate: selectPreset, isPending: selectingPreset } = useMutation({
        mutationFn: ({ sessionId, presetId, customIntent }) =>
            selectExtractPreset({ sessionId, presetId, customIntent }),
        onSuccess: (response, variables) => {
            if (variables?.onSuccess) variables.onSuccess(response)
        },
        onError: (error, variables) => {
            if (variables?.onError) variables.onError(error)
        },
    })

    // Modify configuration via natural language
    const { mutate: modifyConfig, isPending: modifyingConfig } = useMutation({
        mutationFn: ({ sessionId, modification }) =>
            modifyExtractConfig({ sessionId, modification }),
        onSuccess: (response, variables) => {
            if (variables?.onSuccess) variables.onSuccess(response)
        },
        onError: (error, variables) => {
            if (variables?.onError) variables.onError(error)
        },
    })

    // Accept the current configuration
    const { mutate: accept, isPending: accepting } = useMutation({
        mutationFn: ({ sessionId }) => acceptExtractConfig({ sessionId }),
        onSuccess: (response, variables) => {
            if (variables?.onSuccess) variables.onSuccess(response)
        },
        onError: (error, variables) => {
            if (variables?.onError) variables.onError(error)
        },
    })

    // Cancel the conversation
    const { mutate: cancel, isPending: canceling } = useMutation({
        mutationFn: ({ sessionId }) => cancelExtractConversation({ sessionId }),
        onSuccess: (response, variables) => {
            if (variables?.onSuccess) variables.onSuccess(response)
        },
        onError: (error, variables) => {
            if (variables?.onError) variables.onError(error)
        },
    })

    return {
        // Mutations
        startConversation,
        selectPreset,
        modifyConfig,
        accept,
        cancel,

        // Loading states
        startingConversation,
        selectingPreset,
        modifyingConfig,
        accepting,
        canceling,
    }
}
